import { MutationKey } from '@tanstack/react-query';

const base: MutationKey = ['meeting-template'];

export const meetingMutation = {
  // * BASE
  baseKey: base,
  mutate: [...base, 'mutate-meeting'],
  delete: [...base, 'mutate-delete-meeting'],
};
